@if (showCover) {
  <a pxNamedRouterLink="CATALOG_BIB_DETAILS" [pxNamedRouterLinkParams]="{id: catalogRecord.id}">
    <mx-cover-image [catalogRecord]="catalogRecord" [widthRem]="2.5" [heightRem]="2.5"/>
  </a>
}
<div class="grow min-w-0">
  <a pxNamedRouterLink="CATALOG_BIB_DETAILS" [pxNamedRouterLinkParams]="{id: catalogRecord.id}">
    <p mxTruncate [mxTruncateMaxLines]="titleMaxLines" class="text-title-medium w-full">{{ catalogRecord.title }}</p>
  </a>
  @if (isDefined(detail1)) {
    <p [ngClass]="detailTextSizeClasses">{{ detail1 | format: 'REPLACE_EMPTY' }}</p>
  }
  @if (isDefined(detail2)) {
    <p [ngClass]="detailTextSizeClasses">{{ detail2 | format: 'REPLACE_EMPTY' }}</p>
  }
  @if (isDefined(date1Label) && isDefined(date1)) {
    <p class="text-body-small">{{ date1Label }}: <span [class.text-error]="date1Error">{{ date1 | format: ['DATE_ONLY', 'REPLACE_EMPTY'] }}</span></p>
  }
  @if (isDefined(date2Label) && isDefined(date2)) {
    <p class="text-body-small">{{ date2Label }}: {{ date2 | format: ['DATE_ONLY', 'REPLACE_EMPTY'] }}</p>
  }
</div>
